import DefaultLayout from 'components/layout/DefaultLayout';
import { useAuth } from 'providers/auth';
import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  element: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element }) => {
  const { checkAuth } = useAuth();

  return <>{checkAuth() ? <DefaultLayout>{element}</DefaultLayout> : <Navigate to="/login" />}</>;
};

export default ProtectedRoute;
